import React, { useEffect, useState } from 'react';
import { useStoreSettings } from '../../contexts/StoreSettingsContext';

interface Theme {
  id: string;
  name: string;
  cssCode?: string;
  jsCode?: string;
  htmlCode?: string;
}

// قائمة الثيمات المدمجة
const builtInThemes: Record<string, Theme> = {
  default: {
    id: 'default',
    name: 'الثيم الافتراضي',
    cssCode: `
      :root {
        --primary-color: #0d51d6;
        --secondary-color: #f50057;
        --background-color: #ffffff;
        --text-color: #333333;
        --card-background: #ffffff;
        --border-color: #e0e0e0;
        --header-background: #0d51d6;
        --header-text: #ffffff;
        --footer-background: #f5f5f5;
        --footer-text: #333333;
        --button-hover: #0a43b3;
        --card-shadow: 0 2px 4px rgba(0,0,0,0.1);
        --accent-color: #ff6b35;
        --success-color: #4caf50;
        --warning-color: #ff9800;
        --error-color: #f44336;
        --info-color: #2196f3;
      }

      body {
        background-color: var(--background-color) !important;
        color: var(--text-color) !important;
        margin: 0;
        padding: 0;
        font-family: 'Cairo', sans-serif;
        transition: all 0.3s ease;
      }

      .MuiButton-containedPrimary {
        background-color: var(--primary-color) !important;
      }

      .MuiButton-containedPrimary:hover {
        background-color: var(--button-hover) !important;
      }

      .MuiPaper-root {
        background-color: var(--card-background) !important;
        color: var(--text-color) !important;
        box-shadow: var(--card-shadow) !important;
      }

      .store-header {
        background: linear-gradient(135deg, var(--header-background), var(--primary-color)) !important;
        color: var(--header-text) !important;
      }

      .store-footer {
        background-color: var(--footer-background) !important;
        color: var(--footer-text) !important;
      }

      .product-card {
        border: 1px solid var(--border-color) !important;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
      }

      .product-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
      }

      .MuiCard-root {
        box-shadow: var(--card-shadow);
      }

      .store-header {
        background-color: var(--header-background);
        color: var(--header-text);
      }

      .store-footer {
        background-color: var(--footer-background);
        color: var(--footer-text);
      }

      .product-card:hover {
        transform: translateY(-5px);
        transition: transform 0.3s ease;
      }

      /* Mobile-specific styles */
      .MuiBottomNavigationAction-root {
        color: var(--text-color) !important;
      }

      .MuiBottomNavigationAction-root.Mui-selected {
        color: var(--primary-color) !important;
      }

      .mobile-search-bar {
        background-color: var(--card-background) !important;
        color: var(--text-color) !important;
      }

      @media (max-width: 600px) {
        .product-card {
          border-radius: 8px !important;
        }
      }
    `,
    jsCode: '',
    htmlCode: ''
  },
  dark: {
    id: 'dark',
    name: 'الوضع الداكن',
    cssCode: `
      :root {
        --primary-color: #90caf9;
        --secondary-color: #f48fb1;
        --background-color: #121212;
        --text-color: #ffffff;
        --card-background: #1e1e1e;
        --border-color: #333333;
        --header-background: #0a0a0a;
        --header-text: #ffffff;
        --footer-background: #1a1a1a;
        --footer-text: #cccccc;
        --button-hover: #5d8ec9;
        --card-shadow: 0 2px 8px rgba(0,0,0,0.5);
        --accent-color: #bb86fc;
        --success-color: #4caf50;
        --warning-color: #ff9800;
        --error-color: #f44336;
        --info-color: #2196f3;
      }

      body {
        background-color: var(--background-color) !important;
        color: var(--text-color) !important;
        margin: 0;
        padding: 0;
        font-family: 'Cairo', sans-serif;
        transition: all 0.3s ease;
      }

      .MuiPaper-root {
        background-color: var(--card-background) !important;
        color: var(--text-color) !important;
        box-shadow: var(--card-shadow) !important;
      }

      .MuiButton-containedPrimary {
        background-color: var(--primary-color) !important;
        color: #000000 !important;
      }

      .MuiButton-containedPrimary:hover {
        background-color: var(--button-hover) !important;
      }

      .store-header {
        background: linear-gradient(135deg, var(--header-background), #1a1a1a) !important;
        color: var(--header-text) !important;
      }

      .store-footer {
        background-color: var(--footer-background) !important;
        color: var(--footer-text) !important;
      }

      .product-card {
        background-color: var(--card-background) !important;
        border: 1px solid var(--border-color) !important;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
      }

      .product-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 25px rgba(255,255,255,0.1) !important;
      }

      .MuiTextField-root .MuiOutlinedInput-root {
        background-color: var(--card-background) !important;
        color: var(--text-color) !important;
      }

      .MuiTextField-root .MuiInputLabel-root {
        color: var(--text-color) !important;
      }

      .MuiCard-root {
        background-color: var(--card-background);
        color: var(--text-color);
        border: 1px solid var(--border-color);
        box-shadow: var(--card-shadow);
      }

      .MuiButton-containedPrimary {
        background-color: var(--primary-color);
      }

      .MuiButton-containedPrimary:hover {
        background-color: var(--button-hover);
      }

      .MuiInputBase-root {
        color: var(--text-color);
      }

      .MuiOutlinedInput-notchedOutline {
        border-color: var(--border-color);
      }

      .MuiInputLabel-root {
        color: var(--text-color);
        opacity: 0.7;
      }

      .store-header {
        background-color: var(--header-background);
        color: var(--header-text);
      }

      .store-footer {
        background-color: var(--footer-background);
        color: var(--footer-text);
      }

      .product-card {
        transition: transform 0.3s ease, box-shadow 0.3s ease;
      }

      .product-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.8);
      }

      /* تخصيص شريط التمرير */
      ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }

      ::-webkit-scrollbar-track {
        background: #1e1e1e;
      }

      ::-webkit-scrollbar-thumb {
        background: #555;
        border-radius: 4px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: #777;
      }

      /* Mobile-specific styles */
      .MuiBottomNavigationAction-root {
        color: var(--text-color) !important;
      }

      .MuiBottomNavigationAction-root.Mui-selected {
        color: var(--primary-color) !important;
      }

      .mobile-search-bar {
        background-color: var(--card-background) !important;
        color: var(--text-color) !important;
      }
    `,
    jsCode: '',
    htmlCode: ''
  },
  green: {
    id: 'green',
    name: 'الثيم الأخضر',
    cssCode: `
      :root {
        --primary-color: #4caf50;
        --secondary-color: #ff9800;
        --background-color: #f1f8e9;
        --text-color: #33691e;
        --card-background: #ffffff;
        --border-color: #c5e1a5;
        --header-background: #2e7d32;
        --header-text: #ffffff;
        --footer-background: #dcedc8;
        --footer-text: #33691e;
        --button-hover: #388e3c;
        --card-shadow: 0 2px 8px rgba(0,0,0,0.1);
        --accent-color: #8bc34a;
        --success-color: #4caf50;
        --warning-color: #ff9800;
        --error-color: #f44336;
        --info-color: #2196f3;
      }

      body {
        background-color: var(--background-color) !important;
        color: var(--text-color) !important;
        margin: 0;
        padding: 0;
        font-family: 'Cairo', sans-serif;
        transition: all 0.3s ease;
      }

      .MuiPaper-root {
        background-color: var(--card-background) !important;
        color: var(--text-color) !important;
        border-radius: 8px;
        box-shadow: var(--card-shadow) !important;
      }

      .MuiButton-containedPrimary {
        background-color: var(--primary-color) !important;
        color: #ffffff !important;
      }

      .MuiButton-containedPrimary:hover {
        background-color: var(--button-hover) !important;
      }

      .store-header {
        background: linear-gradient(135deg, var(--header-background), var(--primary-color)) !important;
        color: var(--header-text) !important;
      }

      .store-footer {
        background-color: var(--footer-background) !important;
        color: var(--footer-text) !important;
      }

      .product-card {
        border: 1px solid var(--border-color) !important;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
      }

      .product-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 25px rgba(76, 175, 80, 0.2) !important;
      }

      .MuiCard-root {
        background-color: var(--card-background);
        color: var(--text-color);
        border: 1px solid var(--border-color);
        box-shadow: var(--card-shadow);
        border-radius: 8px;
        overflow: hidden;
      }

      .MuiButton-containedPrimary {
        background-color: var(--primary-color);
        border-radius: 20px;
        padding: 6px 16px;
      }

      .MuiButton-containedPrimary:hover {
        background-color: var(--button-hover);
      }

      .MuiButton-containedSecondary {
        background-color: var(--secondary-color);
        border-radius: 20px;
      }

      .MuiButton-containedSecondary:hover {
        background-color: #f57c00;
      }

      .MuiInputBase-root {
        border-radius: 8px;
      }

      .MuiOutlinedInput-notchedOutline {
        border-color: var(--border-color);
      }

      .store-header {
        background-color: var(--header-background);
        color: var(--header-text);
      }

      .store-footer {
        background-color: var(--footer-background);
        color: var(--footer-text);
      }

      .product-card {
        transition: all 0.3s ease;
        border-radius: 12px;
      }

      .product-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 16px rgba(0,0,0,0.1);
        border-color: var(--accent-color);
      }

      .product-card .MuiCardMedia-root {
        transition: transform 0.5s ease;
      }

      .product-card:hover .MuiCardMedia-root {
        transform: scale(1.05);
      }

      /* تخصيص شريط التمرير */
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      ::-webkit-scrollbar-track {
        background: #e8f5e9;
      }

      ::-webkit-scrollbar-thumb {
        background: #81c784;
        border-radius: 5px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: #66bb6a;
      }

      /* Mobile-specific styles */
      .MuiBottomNavigationAction-root {
        color: var(--text-color) !important;
      }

      .MuiBottomNavigationAction-root.Mui-selected {
        color: var(--primary-color) !important;
      }
    `,
    jsCode: `
      // إضافة تأثيرات حركية للمنتجات
      document.addEventListener('DOMContentLoaded', function() {
        const productCards = document.querySelectorAll('.product-card');

        productCards.forEach(card => {
          card.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-8px)';
          });

          card.addEventListener('mouseleave', function() {
            this.style.transform = 'translateY(0)';
          });
        });
      });
    `,
    htmlCode: ''
  },

  // ثيم أزرق عصري
  modern_blue: {
    id: 'modern_blue',
    name: 'الأزرق العصري',
    cssCode: `
      :root {
        --primary-color: #1976d2;
        --secondary-color: #ff4081;
        --background-color: #f8faff;
        --text-color: #1a1a1a;
        --card-background: #ffffff;
        --border-color: #e3f2fd;
        --header-background: #1565c0;
        --header-text: #ffffff;
        --footer-background: #e3f2fd;
        --footer-text: #1565c0;
        --button-hover: #1565c0;
        --card-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
        --accent-color: #42a5f5;
        --success-color: #4caf50;
        --warning-color: #ff9800;
        --error-color: #f44336;
        --info-color: #2196f3;
      }

      body {
        background: linear-gradient(135deg, #f8faff 0%, #e3f2fd 100%) !important;
        color: var(--text-color) !important;
        margin: 0;
        padding: 0;
        font-family: 'Cairo', sans-serif;
        transition: all 0.3s ease;
      }

      .MuiPaper-root {
        background-color: var(--card-background) !important;
        color: var(--text-color) !important;
        border-radius: 12px !important;
        box-shadow: var(--card-shadow) !important;
        border: 1px solid var(--border-color) !important;
      }

      .MuiButton-containedPrimary {
        background: linear-gradient(45deg, var(--primary-color), var(--accent-color)) !important;
        color: #ffffff !important;
        border-radius: 8px !important;
        box-shadow: 0 3px 10px rgba(25, 118, 210, 0.3) !important;
      }

      .MuiButton-containedPrimary:hover {
        background: linear-gradient(45deg, var(--button-hover), var(--primary-color)) !important;
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
      }

      .store-header {
        background: linear-gradient(135deg, var(--header-background), var(--primary-color)) !important;
        color: var(--header-text) !important;
        border-radius: 0 0 20px 20px !important;
      }

      .product-card {
        border: 1px solid var(--border-color) !important;
        border-radius: 12px !important;
        transition: all 0.3s ease;
        overflow: hidden !important;
      }

      .product-card:hover {
        transform: translateY(-8px) scale(1.02);
        box-shadow: 0 12px 30px rgba(25, 118, 210, 0.2) !important;
      }

      /* Mobile-specific styles */
      .MuiBottomNavigationAction-root {
        color: var(--text-color) !important;
      }

      .MuiBottomNavigationAction-root.Mui-selected {
        color: var(--primary-color) !important;
      }
    `,
    jsCode: '',
    htmlCode: ''
  },

  // ثيم وردي أنيق
  elegant_pink: {
    id: 'elegant_pink',
    name: 'الوردي الأنيق',
    cssCode: `
      :root {
        --primary-color: #e91e63;
        --secondary-color: #9c27b0;
        --background-color: #fdf2f8;
        --text-color: #4a1a2a;
        --card-background: #ffffff;
        --border-color: #fce7f3;
        --header-background: #c2185b;
        --header-text: #ffffff;
        --footer-background: #fce7f3;
        --footer-text: #c2185b;
        --button-hover: #c2185b;
        --card-shadow: 0 4px 12px rgba(233, 30, 99, 0.15);
        --accent-color: #f06292;
        --success-color: #4caf50;
        --warning-color: #ff9800;
        --error-color: #f44336;
        --info-color: #2196f3;
      }

      body {
        background: linear-gradient(135deg, #fdf2f8 0%, #fce7f3 100%) !important;
        color: var(--text-color) !important;
        margin: 0;
        padding: 0;
        font-family: 'Cairo', sans-serif;
        transition: all 0.3s ease;
      }

      .MuiPaper-root {
        background-color: var(--card-background) !important;
        color: var(--text-color) !important;
        border-radius: 16px !important;
        box-shadow: var(--card-shadow) !important;
        border: 1px solid var(--border-color) !important;
      }

      .MuiButton-containedPrimary {
        background: linear-gradient(45deg, var(--primary-color), var(--accent-color)) !important;
        color: #ffffff !important;
        border-radius: 25px !important;
        box-shadow: 0 3px 10px rgba(233, 30, 99, 0.3) !important;
      }

      .MuiButton-containedPrimary:hover {
        background: linear-gradient(45deg, var(--button-hover), var(--primary-color)) !important;
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(233, 30, 99, 0.4) !important;
      }

      .store-header {
        background: linear-gradient(135deg, var(--header-background), var(--primary-color)) !important;
        color: var(--header-text) !important;
        border-radius: 0 0 25px 25px !important;
      }

      .product-card {
        border: 1px solid var(--border-color) !important;
        border-radius: 16px !important;
        transition: all 0.3s ease;
        overflow: hidden !important;
      }

      .product-card:hover {
        transform: translateY(-6px) rotate(1deg);
        box-shadow: 0 12px 30px rgba(233, 30, 99, 0.2) !important;
      }

      /* Mobile-specific styles */
      .MuiBottomNavigationAction-root {
        color: var(--text-color) !important;
      }

      .MuiBottomNavigationAction-root.Mui-selected {
        color: var(--primary-color) !important;
      }
    `,
    jsCode: '',
    htmlCode: ''
  },

  // ثيم نون
  noon: {
    id: 'noon',
    name: 'ثيم أصفر (مستوحى من نون)',
    cssCode: `
      :root {
        --primary-color: #fee000;
        --secondary-color: #383838;
        --background-color: #f7f7fa;
        --text-color: #404553;
        --card-background: #ffffff;
        --border-color: #eaeaea;
        --header-background: #fee000;
        --header-text: #404553;
        --footer-background: #ffffff;
        --footer-text: #404553;
        --button-hover: #f3d600;
        --card-shadow: 0 1px 4px rgba(0,0,0,0.08);
      }

      body {
        background-color: var(--background-color) !important;
        color: var(--text-color) !important;
        font-family: 'Cairo', sans-serif;
      }

      .store-header {
        background-color: var(--header-background) !important;
        color: var(--header-text) !important;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
      }

      .store-footer {
        background-color: var(--footer-background) !important;
        color: var(--footer-text) !important;
        border-top: 1px solid var(--border-color) !important;
      }

      .product-card {
        background-color: var(--card-background) !important;
        border: 1px solid var(--border-color) !important;
        border-radius: 8px !important;
        transition: transform 0.2s ease, box-shadow 0.2s ease !important;
        box-shadow: var(--card-shadow) !important;
      }

      .product-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0,0,0,0.1) !important;
        border-color: #cccccc !important;
      }

      /* أزرار نون الأساسية */
      .MuiButton-containedPrimary {
        background-color: var(--primary-color) !important;
        color: #404553 !important;
        font-weight: 700 !important;
        border-radius: 4px !important;
        box-shadow: none !important;
      }

      .MuiButton-containedPrimary:hover {
        background-color: var(--button-hover) !important;
        box-shadow: 0 2px 6px rgba(0,0,0,0.1) !important;
      }

      /* Mobile-specific styles */
      .MuiBottomNavigationAction-root {
        color: var(--text-color) !important;
      }

      .MuiBottomNavigationAction-root.Mui-selected {
        color: var(--primary-color) !important;
      }
    `,
    jsCode: '',
    htmlCode: ''
  },
  
  // ثيم أمازون
  amazon: {
    id: 'amazon',
    name: 'ثيم كلاسيكي (مستوحى من أمازون)',
    cssCode: `
      :root {
        --primary-color: #131921;
        --secondary-color: #febd69;
        --background-color: #eaeded;
        --text-color: #0f1111;
        --card-background: #ffffff;
        --border-color: #d5d9d9;
        --header-background: #131921;
        --header-text: #ffffff;
        --footer-background: #232f3e;
        --footer-text: #ffffff;
        --button-hover: #f7ca00;
        --card-shadow: 0 1px 3px rgba(0,0,0,0.05);
      }

      body {
        background-color: var(--background-color) !important;
        color: var(--text-color) !important;
        font-family: 'Cairo', Arial, sans-serif;
      }

      .store-header {
        background-color: var(--header-background) !important;
        color: var(--header-text) !important;
      }

      .store-footer {
        background-color: var(--footer-background) !important;
        color: var(--footer-text) !important;
      }

      .product-card {
        background-color: var(--card-background) !important;
        border-radius: 4px !important;
        border: 1px solid var(--border-color) !important;
        box-shadow: none !important;
        transition: none !important;
      }

      .product-card:hover {
        border-color: transparent !important;
        box-shadow: 0 0 0 1px #007185, 0 4px 12px rgba(0,0,0,0.15) !important;
      }

      /* أزرار أمازون الأساسية باللون الأصفر الكلاسيكي */
      .MuiButton-containedPrimary {
        background-color: #ffd814 !important;
        color: #0f1111 !important;
        border-radius: 100px !important;
        font-weight: 600 !important;
        border: 1px solid #fcd200 !important;
        box-shadow: 0 2px 5px rgba(213,217,217,0.5) !important;
      }

      .MuiButton-containedPrimary:hover {
        background-color: var(--button-hover) !important;
        border-color: #f2c200 !important;
      }

      /* Mobile-specific styles */
      .MuiBottomNavigationAction-root {
        color: var(--text-color) !important;
      }

      .MuiBottomNavigationAction-root.Mui-selected {
        color: var(--primary-color) !important;
      }
    `,
    jsCode: '',
    htmlCode: ''
  },

  // ثيم علي بابا
  alibaba: {
    id: 'alibaba',
    name: 'ثيم برتقالي (مستوحى من علي بابا)',
    cssCode: `
      :root {
        --primary-color: #ff6a00;
        --secondary-color: #ff9000;
        --background-color: #f2f3f5;
        --text-color: #333333;
        --card-background: #ffffff;
        --border-color: transparent;
        --header-background: #ffffff;
        --header-text: #333333;
        --footer-background: #ffffff;
        --footer-text: #666666;
        --card-shadow: 0 2px 8px rgba(0,0,0,0.04);
      }

      body {
        background-color: var(--background-color) !important;
        color: var(--text-color) !important;
        font-family: 'Cairo', sans-serif;
      }

      .store-header {
        background-color: var(--header-background) !important;
        color: var(--header-text) !important;
        border-bottom: 2px solid var(--primary-color) !important;
        box-shadow: 0 1px 4px rgba(0,0,0,0.05) !important;
      }

      .store-footer {
        background-color: var(--footer-background) !important;
        color: var(--footer-text) !important;
        border-top: 1px solid #e5e5e5 !important;
      }

      .product-card {
        background-color: var(--card-background) !important;
        border-radius: 12px !important;
        border: none !important;
        box-shadow: var(--card-shadow) !important;
        transition: box-shadow 0.3s ease, border 0.3s ease !important;
      }

      .product-card:hover {
        box-shadow: 0 6px 18px rgba(255, 106, 0, 0.15) !important;
      }

      /* أزرار علي بابا بالتدرج البرتقالي الرائع */
      .MuiButton-containedPrimary {
        background: linear-gradient(90deg, #ff9000 0%, #ff5000 100%) !important;
        color: #ffffff !important;
        border-radius: 20px !important;
        font-weight: bold !important;
        border: none !important;
        box-shadow: 0 3px 6px rgba(255, 106, 0, 0.3) !important;
      }

      .MuiButton-containedPrimary:hover {
        background: linear-gradient(90deg, #ff7b00 0%, #e64800 100%) !important;
        box-shadow: 0 4px 8px rgba(255, 106, 0, 0.4) !important;
      }

      /* Mobile-specific styles */
      .MuiBottomNavigationAction-root {
        color: var(--text-color) !important;
      }

      .MuiBottomNavigationAction-root.Mui-selected {
        color: var(--primary-color) !important;
      }
    `,
    jsCode: '',
    htmlCode: ''
  }
};

// مكون لتطبيق الثيم
const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { settings } = useStoreSettings();
  const [customThemes, setCustomThemes] = useState<Record<string, Theme>>({});

  useEffect(() => {
    // محاولة استرداد الثيمات المخصصة من التخزين المحلي
    try {
      const storedThemes = localStorage.getItem('customThemes');
      if (storedThemes) {
        setCustomThemes(JSON.parse(storedThemes));
      }
    } catch (error) {
      console.error('Error loading custom themes from localStorage:', error);
    }
  }, []);

  // تطبيق متغيرات المظهر المخصصة ديناميكياً
  useEffect(() => {
    if (settings?.display) {
      const {
        primaryColor,
        secondaryColor,
        backgroundColor,
        textColor,
        buttonBg,
        buttonText,
        buttonRadius,
        buttonStyle,
        fontFamily
      } = settings.display;

      let customVarsStyle = document.getElementById('store-custom-vars-css');
      if (!customVarsStyle) {
        customVarsStyle = document.createElement('style');
        customVarsStyle.id = 'store-custom-vars-css';
        document.head.appendChild(customVarsStyle);
      }

      let cssCode = ':root {\n';
      if (primaryColor) cssCode += `  --primary-color: ${primaryColor} !important;\n`;
      if (secondaryColor) cssCode += `  --secondary-color: ${secondaryColor} !important;\n`;
      if (backgroundColor) cssCode += `  --background-color: ${backgroundColor} !important;\n`;
      if (textColor) cssCode += `  --text-color: ${textColor} !important;\n`;
      if (buttonBg) cssCode += `  --button-bg: ${buttonBg} !important;\n`;
      if (buttonText) cssCode += `  --button-text: ${buttonText} !important;\n`;
      if (buttonRadius) cssCode += `  --button-radius: ${buttonRadius} !important;\n`;
      if (fontFamily) cssCode += `  --font-family: ${fontFamily} !important;\n`;
      cssCode += '}\n\n';

      if (buttonStyle) {
        if (buttonStyle === 'outline') {
          cssCode += `
            .MuiButton-containedPrimary {
              background-color: transparent !important;
              color: var(--button-bg, var(--primary-color)) !important;
              border: 1px solid var(--button-bg, var(--primary-color)) !important;
              box-shadow: none !important;
            }
            .MuiButton-containedPrimary:hover {
              background-color: rgba(0, 0, 0, 0.04) !important;
            }
          `;
        } else if (buttonStyle === 'flat') {
          cssCode += `
            .MuiButton-containedPrimary {
              background-color: transparent !important;
              color: var(--button-bg, var(--primary-color)) !important;
              border: none !important;
              box-shadow: none !important;
            }
            .MuiButton-containedPrimary:hover {
              background-color: rgba(0, 0, 0, 0.04) !important;
            }
          `;
        } else {
          cssCode += `
            .MuiButton-containedPrimary {
              background-color: var(--button-bg, var(--primary-color)) !important;
              color: var(--button-text, #ffffff) !important;
            }
            .MuiButton-containedPrimary:hover {
              background-color: var(--primary-color) !important;
              filter: brightness(0.9) !important;
            }
          `;
        }
      }

      if (buttonRadius) {
        cssCode += `
          .MuiButton-root, .MuiButton-contained, button, .product-card, .MuiPaper-root {
            border-radius: var(--button-radius, 8px) !important;
          }
        `;
      }

      if (fontFamily) {
        cssCode += `
          body, input, button, select, textarea, .MuiTypography-root {
            font-family: var(--font-family), 'Cairo', sans-serif !important;
          }
        `;
      }

      customVarsStyle.textContent = cssCode;
    }
  }, [settings?.display]);

  useEffect(() => {
    // تطبيق الثيم المختار
    if (settings?.display?.theme) {
      const themeId = settings.display.theme;
      console.log('Applying theme:', themeId);

      // البحث عن الثيم في الثيمات المدمجة أو المخصصة
      const theme = builtInThemes[themeId] || customThemes[themeId];

      if (theme) {
        // إنشاء أو تحديث عنصر style للثيم
        let styleElement = document.getElementById('store-theme-css');
        if (!styleElement) {
          styleElement = document.createElement('style');
          styleElement.id = 'store-theme-css';
          document.head.appendChild(styleElement);
        }
        styleElement.textContent = theme.cssCode || '';

        // تطبيق كود JavaScript إذا كان موجودًا
        if (theme.jsCode) {
          try {
            // إزالة أي سكريبت سابق
            const oldScript = document.getElementById('store-theme-js');
            if (oldScript) {
              oldScript.remove();
            }

            // إنشاء عنصر script جديد
            const scriptElement = document.createElement('script');
            scriptElement.id = 'store-theme-js';
            scriptElement.textContent = theme.jsCode;
            document.body.appendChild(scriptElement);
          } catch (error) {
            console.error('Error applying theme JavaScript:', error);
          }
        }

        // تطبيق كود HTML إذا كان موجودًا
        if (theme.htmlCode) {
          try {
            // إزالة أي HTML سابق
            const oldHtml = document.getElementById('store-theme-html');
            if (oldHtml) {
              oldHtml.remove();
            }

            // إنشاء عنصر div جديد
            const htmlContainer = document.createElement('div');
            htmlContainer.id = 'store-theme-html';
            htmlContainer.innerHTML = theme.htmlCode;
            document.body.appendChild(htmlContainer);
          } catch (error) {
            console.error('Error applying theme HTML:', error);
          }
        }

        // إضافة كلاس للجسم لتسهيل استهداف الثيم
        document.body.className = document.body.className
          .replace(/theme-\w+/g, '')
          .trim();
        document.body.classList.add(`theme-${themeId}`);

        console.log('Theme applied successfully:', themeId);
      } else {
        console.warn('Theme not found:', themeId);
      }
    }
  }, [settings?.display?.theme, customThemes]);

  // تطبيق ثيم محدد
  const applyTheme = (themeId: string) => {
    console.log('Applying theme directly:', themeId);

    // البحث عن الثيم في الثيمات المدمجة أو المخصصة
    const theme = builtInThemes[themeId] || customThemes[themeId];

    if (theme) {
      // إنشاء أو تحديث عنصر style للثيم
      let styleElement = document.getElementById('store-theme-css');
      if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = 'store-theme-css';
        document.head.appendChild(styleElement);
      }
      styleElement.textContent = theme.cssCode || '';

      // تطبيق كود JavaScript إذا كان موجودًا
      if (theme.jsCode) {
        try {
          // إزالة أي سكريبت سابق
          const oldScript = document.getElementById('store-theme-js');
          if (oldScript) {
            oldScript.remove();
          }

          // إنشاء عنصر script جديد
          const scriptElement = document.createElement('script');
          scriptElement.id = 'store-theme-js';
          scriptElement.textContent = theme.jsCode;
          document.body.appendChild(scriptElement);
        } catch (error) {
          console.error('Error applying theme JavaScript:', error);
        }
      }

      // تطبيق كود HTML إذا كان موجودًا
      if (theme.htmlCode) {
        try {
          // إزالة أي HTML سابق
          const oldHtml = document.getElementById('store-theme-html');
          if (oldHtml) {
            oldHtml.remove();
          }

          // إنشاء عنصر div جديد
          const htmlContainer = document.createElement('div');
          htmlContainer.id = 'store-theme-html';
          htmlContainer.innerHTML = theme.htmlCode;
          document.body.appendChild(htmlContainer);
        } catch (error) {
          console.error('Error applying theme HTML:', error);
        }
      }

      // إضافة كلاس للجسم لتسهيل استهداف الثيم
      document.body.className = document.body.className
        .replace(/theme-\w+/g, '')
        .trim();
      document.body.classList.add(`theme-${themeId}`);

      console.log('Theme applied successfully:', themeId);
      return true;
    } else {
      console.warn('Theme not found:', themeId);
      return false;
    }
  };

  // تسجيل ثيم مخصص
  const registerCustomTheme = (theme: Theme) => {
    setCustomThemes(prev => {
      const updated = { ...prev, [theme.id]: theme };
      // حفظ في التخزين المحلي
      localStorage.setItem('customThemes', JSON.stringify(updated));
      return updated;
    });
  };

  // توفير الوظائف للمكونات الأخرى
  (window as any).registerStoreTheme = registerCustomTheme;
  (window as any).applyStoreTheme = applyTheme;

  // الاستماع لأحداث تغيير الثيم
  useEffect(() => {
    const handleThemeChange = (event: CustomEvent) => {
      const { themeId } = event.detail;
      applyTheme(themeId);
    };

    window.addEventListener('themeChanged', handleThemeChange as EventListener);

    return () => {
      window.removeEventListener('themeChanged', handleThemeChange as EventListener);
    };
  }, [customThemes]);

  return <>{children}</>;
};

export default ThemeProvider;
